<div class="info-popup" [class.visible]="isVisible">
  <div class="info-content">
    <div class="info-icon">🔔</div>
    <div class="info-message" [innerHTML]="message"></div>
    <button
      class="info-close"
      (click)="close()"
      aria-label="Close info"
      type="button"
    >
      ✕
    </button>
  </div>
</div>
